import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import debounce from 'debounce';

import { 
	List, 
	Button, 
	Card, 
	Col, 
	Input, 
	InputNumber,
	Row, 
	Table, 
	Tag, 
	Tooltip, 
	Popover, 
	Checkbox, 
	Select, 
	Icon, 
	DatePicker, 
	Spin,
	message
} from 'antd';

import { removeActiveOrder, setActiveOrder } from './actions';

import { 
	_getClaimOrder, 
	_getOrders , 
	_getOrderData, 
	_getSearchCheckedoutOrdersUniversal, 
	_postQbFindAccounts, 
	_getSizeOfOrdersInProgress,
	_getProductsInStockToday,
	_getTodaysOrdersCount,
	_postSetAdminPreference,
	_deleteAdminPreferenceFilterQuery,

} from '../../services';

import HotKeys from 'react-hot-keys'

import './table.css'

import ClaimModal from './claim-modal'
import ExStockTag from '../product-ex-stock/tag';
import countries from './countries'

const { Column } = Table;

const { Option } = Select;

export const renderMainTags = ( order, orderStatus ) => {

	let tags = [
		<Col key="delivery">
			<Tag className="tags" color="#108ee9"> {order.deliveryOption && order.deliveryOption.toUpperCase()} </Tag>
		</Col>,
		<Col key="payment-method">
			<Tag className="tags" color="#f50"> {order.paymentMethod && order.paymentMethod.toUpperCase()}{order.paymentMethod === 'paynow'? `-${order.paynowRefNumber.toUpperCase()}`: ''} </Tag>
		</Col>,
		<Col key="country">
			<Tag className="tags" color="#2db7f5"> {(order.activeShipping && order.activeShipping.country.toUpperCase()) || "?"}</Tag>
		</Col>
	];


	if( order.lastContact && order.lastContact.abandonReminderDate){
		tags.push(
			<Col key="abandoned">
				<Tooltip placement="top" title={ moment(order.lastContact.abandonReminderDate).format('LLLL') }>
					<Tag className="tags" color="#87d068">A</Tag>
				</Tooltip>
			</Col>
		)
	}

	if(order.mobileCheckout){
		tags.push(
			<Col>
				<Tag className="tags" color="#ff4d4f">M</Tag>
			</Col>
		)
	}

	if( order.isVendingMachineOrder ){
		tags.push(
			<Col>
				<Tag className="tags" color="#eb2f96">{order.vendingMachine.name}</Tag>
			</Col>
		);
	}

	// To deprecate once past 310321
	if(order.adminControls.voided){
		tags.push(
			<Col key="voided">
				<Tag 
					className="tags" 
					color="#f5222d">VOID</Tag>
			</Col>
		)
	}

	if ( order.fakeOrder ) {
		tags.push(
			<Col key="fake">
				<Tag 
					className="tags" 
					color="#f5222d">FAKE ORDER</Tag>
			</Col>
		)
	}

	const orderHasExStockProducts = order.products.filter(_product => _product.product.exStock).length > 0
	if (orderHasExStockProducts) {
		tags.push(<ExStockTag />)
	}

	if ( orderStatus && orderStatus.userFirstCheckout ) {
		tags.push(
			<Col key="fake">
				<Tag 
					className="tags" 
					color="#a0d911">First Checkout</Tag>
			</Col>
		)
	}

	return tags;
}

class OrderTable extends React.Component{

	
	render(){
		// const orderData = this.state.orderData && this.state.orderData.sort( (a,b) => {
		// 	return +new Date(b.checkOutDate) - +new Date(a.checkOutDate)
		// });
		const { cartsInStock } = this.state

		// console.log(this.state.orders && this.state.orders[0])


		return (
			<Card
				bordered={false}
				bodyStyle={{ padding: 0, paddingBottom:16 }}
				headStyle={{ padding: "0px 16px" }}
				key={this.props.queryMode === "unclaimed"?"unclaimed":"all"} 
				title={(
					<Row type="flex" justify="space-between" align="middle">
					<Col>
						<Row type="flex" align="middle" justify="space-between" gutter={16}>
							<Col>
								<Row style= {{marginBottom:8}} type="flex" gutter={16} align="middle">
									<Col>
										{this.props.queryMode === "unclaimed"?"Unclaimed":""} Orders - Page {this.state.page}
									</Col>
									<Col>
										{ this.props.queryMode !== "unclaimed" && 
										<Input type="small" style={{ width: 480 }} placeHolder="Search email, company name, product name, offline reference number" onChange={ this.handleSearch } />}
										{/* { this.props.queryMode !== "unclaimed" && <Input type="small" style={{ width: 480 }} placeHolder="Search email, company name, product name, offline reference number" onChange={ this.handleSearch2 } />} */}
									</Col>
									{this.props.queryMode !== "unclaimed" &&
									<Col>
										<Popover
											placement="bottom"
											trigger="click"
											style={{maxHeight:"30%", overflow:"scroll"}}
											content={cartsInStock?<List
														header="Carts with products in today"
														dataSource={cartsInStock}
														renderItem={
															item => (
															<List.Item
															style={{textAlign:"center", cursor:"text"}}>
																<span style={{fontWeight:500}}>{item.adminControls.offlineReferenceNumber && item.adminControls.offlineReferenceNumber}</span>
																<span style={{marginLeft:8}}>{item.refNumber}</span>
															</List.Item>
															)}
														/>:<Spin/>}>
										{/* <Badge count={cartsInStock?cartsInStock.length:0}> */}
										<Icon
											onClick={this.getProductsInStockToday}
											className="icon" 
											type="clock-circle"/>
										{/* </Badge> */}
										</Popover>
									</Col>
									}
									{this.props.queryMode !== "unclaimed" &&
										<Col>
										<HotKeys
											keyName="enter"
											onKeyDown={this.getOrders}
											>
											<Popover
												trigger="click"
												content={
													<div style={{marginBottom:16}}>
													
														<Row  type="flex" gutter={8} align="middle" style={{marginBottom:8}}>
															<Col>
																<Row style={{fontWeight:500}}>Shipping</Row>
																<Row>
																	<Select className="select" value={this.state.filterQuery.shipping} onChange={(value)=>this.handleChangeSelections(value, "shipping")}>
																		<Option value="all">All shipping</Option>
																		<Option value="standard">Standard</Option>
																		<Option value="express">Express</Option>
																		<Option value="international">International</Option>
																	</Select>
																</Row>
															</Col>
															<Col>
																<Row style={{fontWeight:500}}>Payment method</Row>
																<Row>
																	<Select className="select" value={this.state.filterQuery.paymentMethod} onChange={(value)=>this.handleChangeSelections(value, "paymentMethod")}>
																		<Option value="all">All payments</Option>
																		<Option value="card">Card</Option>
																		<Option value="credit">Credit</Option>
																		<Option value="paypal">Paypal</Option>
																		<Option value="manual">Manual</Option>
																		<Option value="transfer">Transfer</Option>
																	</Select>
																</Row>
															</Col>
														</Row>
														<Row type="flex" gutter={8} align="middle" style={{marginBottom:8}}>
															<Col>
																<Row style={{fontWeight:500}}>Country of origin</Row>
																<Row>
																	<Select 
																	showSearch
																	className="select" value={this.state.filterQuery.country} onChange={(value)=>this.handleChangeSelections(value, "country")}>
																		<Option value="all">All countries</Option>
																		{countries.map(_country=>
																				<Option value={_country.Code}>{_country.Code}</Option>
																		)}
																	</Select>
																</Row>
																{/* <Row>
																<a 
																style={{fontSize:10}}
																target="_blank"
																href="https://www.nationsonline.org/oneworld/country_code_list.htm">Search country codes</a>
																</Row> */}
															</Col>
															<Col>
															<Row style={{fontWeight:500}}>Deliveries</Row>
															<Row>
															<Select 
																className="select" value={this.state.filterQuery.deliveryNot} onChange={(value)=>this.handleChangeDeliveryNotSelections(value)}>
																		
																	<Option value="all">All orders</Option>
																	<Option value="scheduled">Not scheduled</Option>
																	<Option value="completed">Not completed</Option>
																	
															</Select>
															</Row>
															</Col>
														</Row>
														<Row type="flex" gutter={8} align="middle" style={{marginBottom:16}}>
															<Col>
																<Row style={{fontWeight:500}}>From</Row>
																<Row>
																	<DatePicker value={this.state.filterQuery.fromDate?this.state.filterQuery.fromDate:undefined} onChange={(value)=>this.handleChangeSelections(value, "fromDate")}/>
																</Row>
															</Col>
															<Col>
																<Row style={{fontWeight:500}}>To</Row>
																<Row>
																	<DatePicker value={this.state.filterQuery.toDate? this.state.filterQuery.toDate:undefined}
																	onChange={(value)=>this.handleChangeSelections(value, "toDate")}/>	
																</Row>
															</Col>
														</Row>
														<Row type="flex" gutter={8} align="middle" style={{marginBottom:8}}>
														<Col>
															<Checkbox onChange={this.handleChangeShowInProgress} checked={this.state.filterQuery.inProgress}>In Progress</Checkbox>
														</Col>
														<Col>
															<Checkbox onChange={this.handleChangeShowUnclaimed} checked={this.state.filterQuery.unclaimed}>Unclaimed</Checkbox>
														</Col>
														<Col>
															<Checkbox
															checked={this.state.filterQuery.myOrder} onChange={this.handleChangeMyOrder}>My orders</Checkbox>
														</Col>
														</Row>
														<Row type="flex" gutter={8} align="middle" style={{marginBottom:8}}>
														<Col>
															<Checkbox onChange={this.handleChangeShowAwaitingPayment} checked={this.state.filterQuery.awaitingPayment}>Awaiting payment</Checkbox>
														</Col>
														<Col>
															<Checkbox onChange={this.handleChangeShowVoided} checked={this.state.filterQuery.voided}>Voided</Checkbox>
														</Col>
														</Row>
														<Row type="flex" gutter={8} align="middle" justify="end">
														<Col>
														<Popover
															trigger="click"
															title="Give this query a name"
															content={
																<div>
																	<Input 
																		style={{marginBottom:16}}
																		onChange={this.handleChangeFilterQueryName}
																	/>
																	<Row
																		type="flex"
																		justify="end"
																	>
																	<Button 
																		type="primary"
																		onClick={this.handleSaveFilters}
																		>Ok</Button>
																	</Row>
																</div>
															}
															>
															<Button>
																Save
															</Button>
														</Popover>
														</Col>
														<Col>
															<Button onClick = {this.handleResetFilters}>
																Reset
															</Button>
														</Col>
														<Col>
															<Button type="primary" onClick = {this.getOrders}>
																Apply
															</Button>
														</Col>
														</Row>
												
													</div>
												}>
												<Icon className="icon" type="bars"/>
											</Popover>
											</HotKeys>
										</Col>}

									<Col>
										{this.props.queryMode !== "unclaimed"? this.renderAdminPrefencesButton() : null}
									</Col>
									<Col>
										<Button 
											type="primary" 
											shape="circle" 
											icon="reload" 
											onClick={ this.getOrders } />
									</Col>
								</Row>
							</Col>
						</Row>
						<Row style={{marginBottom:4}}>
							{this.props.queryMode !== "unclaimed"? this.renderFilterQueryButtons() : null}
						</Row>
						<Row>
							{this.props.queryMode !== "unclaimed"? this.renderFilterQueryTags() : null}
						</Row>
						</Col>
						<Col>
							{this.props.queryMode !== "unclaimed"? this.renderTodaysOrdersCard() : null}
						</Col>
					</Row>
				)}>

				{
					this.state.showClaimModal ? (
						<ClaimModal 
						handleClaimOrder={this.handleClaimOrder}
						closeClaimModal={this.closeClaimModal}
						visible={this.state.showClaimModal}
						order={this.state.claimOrder}
						/>
					) : null
				}

				

				{/* orders table */}
				<Table 
					bodyStyle={{fontSize: this.state.tableFontSize}}
					loading={this.state.loading}
					size="middle"
					pagination={{
						current: this.state.page,
						pageSize:40,
						total: this.state.count,
						onChange: this.handlePageChange
					}}
					locale={{
						emptyText: `No ${this.props.unclaimed?'Unclaimed ':''}Orders`
					}}
					dataSource={this.state.orders }
					onRow={(record, index) => ({
						onClick: (event) => {
							this.props.unclaimed?this.showClaimModal(record):this.handleViewOrder(record)
						}
					})}
					>
					
					{/* <Column 
						title="#" 
						dataIndex="_id"
						key="_id"
						/> */}
					<Column title={(
						<span style={{ paddingLeft: 8 }}>
							#
						</span>
					)}
						key="index"
						render={ (text, record, index) => {
							return (
								<div style={{textAlign:"center"}}>
									{this.state.count - (index + ((this.state.page - 1) * 40))}
								</div>
							)
						} }/>

					<Column 
						title="Ref" 
						// dataIndex="refNumber"
						key="refNumber"
						render={ (text, order ) => {
							
							let offlineReferenceNumber = order.adminControls.offlineReferenceNumber;
							
							return (
								
								<Tooltip 
									placement="top" 
									title={ order.refNumber }>
									<span>
										{offlineReferenceNumber? 
											offlineReferenceNumber.split("-")[1] + "-" +  offlineReferenceNumber.split("-")[2]
										:
											order.refNumber
										}
									</span>
								</Tooltip>
							)
						}}
						/>
					
					<Column 
						title="Date" 
						// dataIndex="lastContact.invoiceDate"
						render={
							order =>{

								const date = order.checkOutDate?order.checkOutDate:order.lastContact.invoiceDate

								return (
									<Tooltip 
										placement="top" 
										title={ moment(date).format('LLLL') }>
										<span>{moment(date).format('DD/MM/YYYY')}</span>
									</Tooltip>
								)
							} 
						}
						/>
					
					<Column 
						title="Name" 
						dataIndex="activeShipping.name"
						render={ name => (
							<span>{name}</span>
							// <span>{name && name.length > 20? `${name.substring(0,20)}..`: name}</span>
						)}
						/>
					<Column
						title="HP"
						dataIndex="activeShipping.hp"
						render={ hp => (
							<span>{hp}</span>
						)}
						/>
					<Column 
						title="Company" 
						render={ 
							(order) => (
							<Tooltip
								title={order.activeBilling ? order.activeBilling.companyName : 'No billing company'}
							>
								<span>{order.activeShipping && order.activeShipping.companyName}</span>
							</Tooltip>
						)}
						/>
					<Column 
						title="Details"
						key="details"
						width={250}
						render={
							( order ) => (
								<Row gutter={8} type="flex">
									{renderMainTags( order )}
								</Row>
							)
						}
						/>
					{/* <Column 		
						title={(
						<div style={{textAlign:"center"}}>
							<span>
								QB
							</span>
						</div>)}
						dataIndex=""
						render = {()=>(
							<Row type="flex" align="middle" justify="center">
								<Button
									className="table-btn">INV</Button>
								<Button
									className="table-btn">DO</Button>
							</Row>
						)}
						/> */}
					{this.props.queryMode !== "unclaimed"?
					<Column
						width={"25%"}
						title="Progress"
						render={ (text, order)  =>{

							let content = (
								
								<Row className="progress-bar-modal">
									{this.renderProgressBar(order, "inStock", "In Stock")}
								
									{this.renderProgressBar(order, "deliveryScheduled", "Deliveries Scheduled")}
								
									{this.renderProgressBar(order, "deliveryCompleted", "Deliveries Completed")}

									{this.renderProgressBar(order, "paymentAdvice", "Payment Advice")}

									{order.adminControls.progressAmended?
									<Row>
										<span
											style={{
												fontSize:10,
												color: "#f5222d"
											}}
										>The products in this order have been amended</span>
									</Row>
									:
									null
									}
								</Row>
					
							)

							if(order.adminControls.progress){

								if( order.adminControls.awaitingPaymentAdvice ){
									return (
										<Row
											type="flex"
											justify="center" 
											style={{width:"95%"}}>
											 <Tag 
											 className="tags"
											 color="#fa8c16">AWAITING PAYMENT</Tag>
										</Row>
									)
								}
								else {
									return(
										<Popover
											placement="left"
											content={content}>
											{this.renderTotalProgressBar(order)}
										</Popover>
									)
								}
							} else {
								return "-"
							}
						}}
					/>
					:
					null
					}
				</Table>
				{/* <Button onClick={this.sendFind}>find</Button> */}
			</Card>
		)
	}

	constructor( props ){
		super(props);
		const { adminPreferences } = this.props.user.data
		const { filterQuery, defaultFilterId } = adminPreferences
		
		// let unclaimed,
		// 		myOrder;

		// // if(this.props.unclaimed){
		// 	unclaimed = true;
		// 	myOrder = false;
		// } else {
		// 	unclaimed = false;
		// 	myOrder = true;
		// }

		this.state = {
			tableFontSize: adminPreferences.fontSize ? adminPreferences.fontSize : 11,
			sizeOfOrdersInProgress:false,
			searchTerm:false,
			cartsInStock:false,
			page: 1,
			loading: true,
			showClaimModal:false,
			claimOrder:false,	
			todaysOrdersCount:false,
			initialCount:true,
			filterQuery:{
				name: false,
				shipping: "all",
				paymentMethod:"all",
				country:"all",
				fromDate:false,
				toDate:false,
				inProgress:false,
				unclaimed: this.props.unclaimed,
				myOrder: this.props.unclaimed?false:true,
				awaitingPayment:false,
				voided:false,
				deliveryNot:"all"
			},
			deleteFilterQueryId: filterQuery && filterQuery.length > 0? filterQuery[0]._id : null,
			deletingAdminPreference: false,
			defaultFilterId
		}

		this.handleSearchUpdateState = debounce(this.handleSearchUpdateState,300);

		
		// this.pollSizeOfOrdersInProgress()
		
	}

	componentDidMount(){
		const { adminPreferences } = this.props.user.data
		const { filterQuery, defaultFilterId } = adminPreferences
		if(this.state.defaultFilterId && !this.props.unclaimed){
			let defaultFilter = filterQuery.filter( _filterQuery => _filterQuery._id == defaultFilterId)[0]	
			this.setFilterQuery(defaultFilter)
		} else {
			this.pollOrders()
		};
	}

	componentWillReceiveProps = ( nextProps, nextState ) => {
		if(this.props.queryMode !== nextProps.queryMode || this.props.orderStatusFilter !== nextProps.orderStatusFilter ){

			this.setState({ page: 1 }, () => {
				this.getOrders();
			})

		}

	}

	pollOrders = () => { 
			let promise = this.getAjaxQuery();

		promise.then(
			res => {
				
				this.setState({
					loading: false,
					orders: res.data.orders,
					count: res.data.count
				}, () => {
					setTimeout( this.pollOrders, 5000 )
				})

			}
		)
		

		
	}


	pollSizeOfOrdersInProgress=()=>{
		
		_getSizeOfOrdersInProgress()
		.then(res => {
			this.setState({
				sizeOfOrdersInProgress:res.data.count
			}, ()=>{
				setTimeout(this.pollSizeOfOrdersInProgress, 5000)
			})
		})

	}

	sendFind =() =>{
		_postQbFindAccounts()
	}

	

	getAjaxQuery = () => {

		let {
			shipping, 
			paymentMethod, 
			country, 
			fromDate, 
			toDate, 
			inProgress, 
			unclaimed, 
			myOrder,
			awaitingPayment,
			voided,
			deliveryNot
		} = this.state.filterQuery

		// if(!this.props.unclaimed){
		// 	console.log(this.state.filterQuery)
		// }

		if( this.state.searchTerm ){
			return _getSearchCheckedoutOrdersUniversal({
				// filterQuery:this.state.filterQuery,
				shipping,
				paymentMethod,
				country,
				fromDate,
				toDate,
				inProgress,
				unclaimed,
				myOrder,
				awaitingPayment,
				voided,
				deliveryNot,
				page: this.state.page,

				
				limit: 40,
				searchTerm: this.state.searchTerm
			});
		} else {
			return _getOrders({
				shipping,
				paymentMethod,
				country,
				fromDate,
				toDate,
				inProgress,
				unclaimed,
				myOrder,
				awaitingPayment,
				voided,
				deliveryNot,
				page: this.state.page,
				
			});
		}
	}

	getOrders = (  ) => {

		this.setState({ loading: true }, () => {

			let promise = this.getAjaxQuery();

			promise
				.then( res => {
					this.setState({
						loading: false,
						orders: res.data.orders,
						count: res.data.count
					})
				})
				.catch( err => {

					this.setState({
						loading: false,
						orders: err.response.data.orders,
						count: err.response.data.count
					})
					// err.response
				})
		})

	}

	showClaimModal = (order) => {
		
		
		this.setState({
			showClaimModal:true,
			claimOrder:order
		});

	}

	closeClaimModal = () =>{
		this.setState({
			showClaimModal:false
		})
	}

	
	handleResetFilters = () =>{
		
		let filterQuery = {
			shipping: "all",
			paymentMethod:"all",
			country:"all",
			fromDate:false,
			toDate:false,
			inProgress:false,
			unclaimed:false,
			myOrder:true,
			awaitingPayment:false,
			voided:false,
			deliveryNot:"all"
		}
		
		this.setState({filterQuery}, ()=>this.getOrders())
	}
	
	handleSaveFilters = () =>{

		let { filterQuery } = this.state

		if(filterQuery.name.length < 5){

			message.warning("Query name must be informative!")

		} else {

			_postSetAdminPreference({
				userId: this.props.user.data._id,
				type: "filterQuery",
				value: filterQuery
			})
			.then( res => {
				message.success("Preference saved! Please refresh.")
			})

		}


	} 

	setFilterQueryFalse=(key)=>{
		this.setState({
			filterQuery: {
				...this.state.filterQuery,
				[key]: false
			}
		}, ()=> this.getOrders())
	}

	setFilterQueryAll=(key)=>{
		let filterQuery = this.state.filterQuery
		filterQuery[key] = "all"

		this.setState({filterQuery}, ()=> this.getOrders())
	}

	setUserPreferenceFontSize = ()=>{
		_postSetAdminPreference({
			userId:this.props.user.data._id,
			type:'fontSize',
			value:this.state.tableFontSize
		})
		.then( res =>{
			message.success("Preference saved! Please refresh.")
		})
	}

	handleChangeFilterQueryName = (e) =>{

		let { filterQuery } = this.state

		filterQuery.name = e.target.value
		
		this.setState({filterQuery})

	}

	handleChangeShowInProgress = (e) =>{
		let filterQuery = this.state.filterQuery
		filterQuery.inProgress = e.target.checked

		this.setState({filterQuery})
	}

	handleChangeShowUnclaimed = (e) =>{

		this.setState({
			filterQuery: {
				...this.state.filterQuery,
				unclaimed: e.target.checked
			}
		});

	}

	handleChangeMyOrder = (e) =>{
		let filterQuery = this.state.filterQuery
		
		if(e.target.checked){
			filterQuery.myOrder = this.props.user.data._id
		} else {
			filterQuery.myOrder = false
		}

		this.setState({filterQuery})
	}

	handleChangeShowAwaitingPayment = (e) =>{
		
		let { filterQuery } = this.state

		if( e.target.checked ){

			filterQuery.awaitingPayment = true

		} else {

			filterQuery.awaitingPayment = false

		}

		this.setState({filterQuery})

	}

	handleChangeShowVoided = (e) =>{
		
		let { filterQuery } = this.state

		if( e.target.checked ){

			filterQuery.voided = true

		} else {

			filterQuery.voided = false

		}

		this.setState({filterQuery})

	}

	handleChangeDeliveryNotSelections = (value) =>{

		let filterQuery = {
			...this.state.filterQuery,
			deliveryNot: value
		}

		this.setState({filterQuery})

	}

	handleChangeDefaultFilterId = (value) =>{

		this.setState({defaultFilterId: value})

		_postSetAdminPreference({
			userId: this.props.user.data._id,
			type: 'defaultFilterId',
			value
		})
		.then( res => {
			message.success("Preference saved! Please refresh.")
		})

	}

	handleChangeSelections = (value, key) =>{


		let filterQuery = this.state.filterQuery
		filterQuery[key] = value === null ? false : value
		this.setState({filterQuery})
	}

	handleOnChangePaid = (cartId) => {
		console.log(cartId)
	}

	handleClaimOrder=(order)=>{

		let orderId = order._id

		_getClaimOrder( orderId )
			.then( () => {			
				this.handleViewOrder(order);
				this.getOrders();
				this.closeClaimModal();

			})
			.catch( () => {})

	}

	handleDeleteAdminPreferenceFilterQuery = () =>{

		this.setState({deletingAdminPreference: true})
		
		_deleteAdminPreferenceFilterQuery({
			userId: this.props.user.data._id,
			queryId: this.state.deleteFilterQueryId
		})
		.then( res => {
			this.setState({deletingAdminPreference:false})
			message.success("Preference saved! Please refresh.")
		})

	}

	handleSearch = ( e ) => {

		this.handleSearchUpdateState( e.target.value )

	}

	handleSearchUpdateState = (searchTerm) => {
		this.setState({ page: 1, searchTerm }, this.getOrders );
	}

	handlePageChange = ( page ) => {
		this.setState({
			 page
		}, () => {
			this.getOrders() 
		})
	}

	handleViewOrder = (order) => {

		_getOrderData( order._id )
			.then( res => {
				this.props.setActiveOrder(res.data.order);				
			})

		// this.props.setActiveOrder(order);
	}

	renderAdminPrefencesButton = () => {

		return (
			<Popover
				trigger="click"
				title="Admin Preferences"
				content={this.renderAdminPreferencesContent()}
			>
				<Icon type="setting" />
			</Popover>
		)
	}

	renderAdminPreferencesContent = () => {

		const { adminPreferences } = this.props.user.data

		return( 
			//fontsize
			<div
				style={{padding:"12px 16px 24px 12px"}}
			>
				<Row style={{marginBottom:12}}>
					<Row>
						<span style={{fontWeight:500}}>Font Size</span>
					</Row>
					<Row type="flex" gutter={4}>
						<Col>
							<InputNumber
								onChange={(value) => this.setState({tableFontSize:value})}
								defaultValue = {adminPreferences.fontSize}
							/>
						</Col>
						<Col>
							<Button
								onClick={this.setUserPreferenceFontSize}
							>Ok</Button>
						</Col>
					</Row>
				</Row>
				{adminPreferences.filterQuery && adminPreferences.filterQuery.length > 0 &&
				<div>
					<Row>
						<span style={{fontWeight:500}}>Saved Filters</span>
					</Row>
					<Row type="flex" gutter={4}>
						<Col>
						<Select
							placeholder="Delete Filter"
							onChange={(value)=>this.setState({deleteFilterQueryId:value})}
							value={this.state.deleteFilterQueryId}
							style={{width:150}}
						>
						{
							adminPreferences.filterQuery.map( (_filterQuery, index) => {
								return(
									<Option value={_filterQuery._id}>
										<span>{_filterQuery.name}</span>
									</Option>
								)
							})
						}
						</Select>
						</Col>
						<Col>
						<Button
							disabled={this.state.deletingAdminPreference}
							onClick={this.handleDeleteAdminPreferenceFilterQuery}
						>Delete</Button>
						</Col>
					</Row>
				</div>}
				{adminPreferences.filterQuery && adminPreferences.filterQuery.length > 0 &&
				<div>
					<Row>
						<span style={{fontWeight:500}}>Default Filter</span>
					</Row>
					<Row type="flex" gutter={4}>
						<Select
							onChange={this.handleChangeDefaultFilterId}
							value={this.state.defaultFilterId}
							style={{width:150}}
						>
						{
							adminPreferences.filterQuery.map( (_filterQuery, index) => {
								return(
									<Option value={_filterQuery._id}>
										<span>{_filterQuery.name}</span>
									</Option>
								)
							})
						}
						<Option value={null}>
							<span>No default</span>
						</Option>
						</Select>
					</Row>
				</div>}

			</div>
		)

	}

	renderFilterQueryButtons = () => {

		const { adminPreferences } = this.props.user.data

		if( adminPreferences && adminPreferences.filterQuery && adminPreferences.filterQuery.length > 0 ){

			const { filterQuery } = adminPreferences

			return (
				<Row 
					type="flex">
					<Col>
						<span
							style={{
								marginRight:8,
								fontSize:14
							}}
						> <Icon type="star" /> Favorites </span>
					</Col>
					{filterQuery.map ( (_filterQuery) =>
						<Col>
						<Button
							type={ _filterQuery._id === this.state.filterQuery._id? "primary": "default" }
							className="filter-buttons"
							size="small"
							onClick={()=>this.setFilterQuery(_filterQuery)}
						>
						{_filterQuery.name}
						</Button>
						</Col>
				
					)}
				</Row>
			)

		} else {
			
			return null
		
		}
	
	}

	setFilterQuery = (_filterQuery) => {

		const {
			name,
			shipping,
			paymentMethod,
			country,
			inProgress,
			unclaimed,
			myOrder,
			awaitingPayment,
			voided,
			deliveryNot,
			_id
		} = _filterQuery

		this.setState({
			page: 1,
			filterQuery:{
				_id,
				name,
				shipping,
				paymentMethod,
				country,
				inProgress,
				unclaimed,
				myOrder,
				awaitingPayment,
				voided,
				deliveryNot,
				fromDate: _filterQuery.fromDate ? moment(_filterQuery.fromDate) : false,
				toDate: _filterQuery.toDate? moment(_filterQuery.toDate) : false
		}}, ()=>{
			this.getOrders()
		})

	}

	renderFilterQueryTags = ( ) => {
		
		return (
				<Row gutter={4}>
					{this.state.filterQuery.shipping !== "all"?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryAll("shipping")}><Icon type="close"/>{this.state.filterQuery.shipping}
					</Button>
					:
					null}
					{this.state.filterQuery.paymentMethod !== "all"?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryAll("paymentMethod")}><Icon type="close"/>{this.state.filterQuery.paymentMethod}
					</Button>
					:
					null}
					{this.state.filterQuery.country !== "all"?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryAll("country")}><Icon type="close"/>{this.state.filterQuery.country}
					</Button>
					:
					null}

					{this.state.filterQuery.deliveryNot !== "all"?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryAll("deliveryNot")}><Icon type="close"/>
						<span>not {this.state.filterQuery.deliveryNot}</span>
					</Button>
					:
					null}

					{this.state.filterQuery.fromDate !== false?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryFalse("fromDate")}><Icon type="close"/>
						<span>from {moment(this.state.filterQuery.fromDate).format("YYYY-MM-DD")}</span>
					</Button>
					:
					null}
					{this.state.filterQuery.toDate !== false?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryFalse("toDate")}><Icon type="close"/>
						<span>to {moment(this.state.filterQuery.toDate).format("YYYY-MM-DD")}</span>
					</Button>
					:
					null}
					{this.state.filterQuery.inProgress !== false?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryFalse("inProgress")}><Icon type="close"/>in progress
					</Button>
					:
					null}
					{this.state.filterQuery.unclaimed !== false?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryFalse("unclaimed")}><Icon type="close"/>unclaimed
					</Button>
					:
					null}
					{this.state.filterQuery.myOrder !== false?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryFalse("myOrder")}><Icon type="close"/>my orders
					</Button>
					:
					null}
					{this.state.filterQuery.awaitingPayment !== false?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryFalse("awaitingPayment")}><Icon type="close"/>awaiting payment
					</Button>
					:
					null}
					{this.state.filterQuery.voided !== false?
					<Button  
						size="small"
						className="filter-tags"
						onClick={()=>this.setFilterQueryFalse("voided")}><Icon type="close"/>voided
					</Button>
					:
					null}
				</Row>
		)
	}

	getTodaysOrdersCount = () =>{

		this.setState({todaysOrdersCountLoading: true})

		_getTodaysOrdersCount()
		.then( res => {
			this.setState({todaysOrdersCount: res.data.count, todaysOrdersCountLoading: false})
		})
	}

	renderTodaysOrdersCard = () =>{
		return(
			<Card
				actions={[
					<Icon 
					onClick={this.getTodaysOrdersCount}
					type="play-circle" />
				]}
				className="todays-orders-card"
				title={
				<span
					style={{
						fontSize:12
					}}
				>
					Today's Checkouts
				</span>}
				style={{borderRadius:10}}
				bodyStyle={{
					padding:12,
					fontSize:24,
					textAlign:"center"
				}}
			>	
				{!this.state.todaysOrdersCountLoading?
					this.state.todaysOrdersCount?
						this.state.todaysOrdersCount
						:
						<Icon type="question"/>
					:
					<Spin />
				}
			</Card>
		)
	}

	renderTotalProgressBar = (order) => {

		const { progress } = order.adminControls

		if(progress){

			let totalCurrent = 0
			let totalTotal = 0
			
			Object.keys(progress).map( _key => {

				totalCurrent += progress[_key].current
				totalTotal += progress[_key].total

				return _key;
			});

			
			let percentage = totalCurrent/totalTotal*100
			let color = this.getProgressBarColor(percentage)

			return (
				<Row>
					<Row 
					className="progress-bar" style={{
						width:"95%",
						}}>
						<Row type="flex" justify="end" align="middle" className={`progress`} 
							style={{
								color: order.adminControls.progressAmended?"#f5222d" : "#ffffff",
								overflow:"hidden",
								background:color,
								minWidth:"12%",
								width: percentage + "%" }}>
							{Math.floor(percentage) + "%"}
						</Row>
					</Row>
				</Row>
			)
		}

	}

	renderProgressBar = (order, tag, title) =>{
		
		// let adminControlsProgress = order.adminControls.progress
		// let progress

		// if(!(adminControlsProgress && adminControlsProgress[tag] && adminControlsProgress[tag].percentage)){
		// 	progress = 0
		// } else {
		// 	progress = adminControlsProgress[tag].percentage
		// }
		if(order.adminControls.progress && Object.keys(order.adminControls.progress).length === 4){

			let percentage = order.adminControls.progress[tag].percentage * 100;
	
			let color = this.getProgressBarColor(percentage)
	
			return (
				<Row style={{marginBottom:8}}>
					<Row type="flex" justify="space-between" className="progress-name">
						<Col>{title}</Col>
						<Col>
							{order.adminControls.progress[tag].current}/{order.adminControls.progress[tag].total}
						</Col>
					</Row>
					<Row className="progress-bar">
						<Row type="flex" justify="end" className={`progress`} style={{
							overflow:"hidden",
							width: percentage + "%" ,
							background:color
							}}>
							{Math.floor(percentage) + "%"}
						</Row>
					</Row>
				</Row>
			)
		}

	}


	getProgressBarColor=(percentage)=>{

		let color
		
		if ( percentage === 0 ){
			color = "#EBF5FF"
		}
		else if( percentage < 10 ){
			color = "#C2E1FF"
		}
		else if( percentage < 20 ){
			color = "#99CEFF"
		}
		else if( percentage < 30 ){
			color = "#70BAFF"
		}
		else if( percentage < 40 ){
			color = "#47A6FF"
		}
		else if( percentage < 50 ){
			color = "#1890FF"
		}
		else if( percentage < 60 ){
			color = "#007EF5"
		}
		else if( percentage < 70 ){
			color = "#0069CC"
		}
		else if( percentage < 80 ){
			color = "#0054A3"
		}
		else if( percentage < 90 ){
			color = "#003F7A"
		}
		else if( percentage <= 100 ){
			color = "#002A52"
		}
		
		return color
	}

	getProductsInStockToday = () =>{

		_getProductsInStockToday()
		.then(res=>{
			
			const cartsInStock = res.data.carts

			this.setState({cartsInStock})

		})
	}

}

export default connect(
	state => ({user:state.user}),
	dispatch => ({
		// claimOrder: (orderId) => dispatch( claimOrder(orderId)),
		removeActiveOrder:() => dispatch( removeActiveOrder() ),
		setActiveOrder: (order) => dispatch( setActiveOrder(order) )
	})
)(OrderTable);


// WEBPACK FOOTER //
// ./src/components/orders-v2/table.js